import store from "../../store";
import { loginResponse } from "../../store/Auth/actions";
import {
  showHideLoader,
  hideLoaderOverlay
} from "../../store/Loader/actions";
import { clearAdminData } from "../../utils/Auth";
import { showErrorMsg } from "../../utils/Helpers";
import messages from "../../assets/locale/messages";

export const isHandlerEnabled = (config = {}) => {
  return Object.hasOwn(config, "handlerEnabled") &&
    !config.handlerEnabled
    ? false
    : true;
};

// This is used to handle remove loader only if all pending requests are resolved
let numberOfAjaxCAllPending = 0;

export const requestHandler = (request) => {
  numberOfAjaxCAllPending++;
  if (isHandlerEnabled(request)) {
    store.dispatch(showHideLoader(true));
    if (
      request?.url === "/api/Notification/GetNotifications" &&
      request?.params?.reuqestType === "initial"
    ) {
      store.dispatch(hideLoaderOverlay(true));
    }
    /*
     * In case of loader not needed in searching data tables
     * !request.params?.search && store.dispatch(showHideLoader(true));
     */

    const locale = localStorage.getItem("lang");
    request.headers.locale = locale;

    const adminData =
      JSON.parse(localStorage.getItem("admin")) ||
      JSON.parse(sessionStorage.getItem("admin"));
    const token = adminData?.Token;
    if (token) {
      request.headers.Authorization = `Bearer ${token}`;
    }
  }
  return request;
};

export const successHandler = (response) => {
  numberOfAjaxCAllPending--;
  if (isHandlerEnabled(response)) {
    if (numberOfAjaxCAllPending === 0) {
      store.dispatch(showHideLoader(false));
    }
  }
  return response;
};

export const errorHandler = (error) => {
  const lang = localStorage.getItem("lang");
  numberOfAjaxCAllPending--;
  if (isHandlerEnabled(error.config)) {
    if (numberOfAjaxCAllPending === 0) {
      store.dispatch(showHideLoader(false));
    }
  }
  if (error?.response?.status === 401) {
    store.dispatch(loginResponse({}));
    clearAdminData();
    /*
     * Yield clearFirebaseToken();
     * yield generateFirebaseToken();
     */
  } else if (
    error?.message === "Network Error" &&
    !navigator.onLine
  ) {
    showErrorMsg(messages[lang].shared.internetConnection);
  } else {
    showErrorMsg(messages[lang].shared.generalErrMsg);
  }
  return Promise.reject({ ...error });
};
